export default {
  ICHLApi: {
    hotlineApi: {
      getWaitingList: 'api/hotlineApi/getWaitingList',
      getEffectiveList: 'api/hotlineApi/getEffectiveList',
      exportEffectiveList: 'api/hotlineApi/exportEffectiveList',
      del: 'api/hotlineApi/del',
      ledgerInfo: 'api/hotlineApi/ledgerInfo',
      saveOrUpdate: 'api/hotlineApi/saveOrUpdate',
      emergencyLedger: 'api/hotlineApi/emergencyLedger',
      getCallTypeOptions: 'api/hotlineApi/getCallTypeOptions',
      popLedger: 'api/hotlineApi/popLedger',
      ledgerConInfo: 'api/hotlineApi/ledgerConInfo',
    },
    bussinessType: {
      bussinessTypeTree: 'api/hotlineApi/bussinessType/bussinessTypeTree',
      addBussinessType: 'api/hotlineApi/bussinessType/addBussinessType',
      updateBussinessType: 'api/hotlineApi/bussinessType/updateBussinessType',
      delBussinessType: 'api/hotlineApi/bussinessType/delBussinessType',
      treeSelect: 'api/hotlineApi/bussinessType/treeSelect',
    },
    tag: {
      tagOptions: 'api/hotlineApi/tag/tagOptions',
      pageList: 'api/hotlineApi/tag/pageList',
      saveOrUpdate: 'api/hotlineApi/tag/saveOrUpdate',
      delTag: 'api/hotlineApi/tag/delTag',
    },
    MSSupportApi: {
      getRecordList: 'api/MSSupportApi/getRecordList',
      exportRecordList: 'api/MSSupportApi/exportRecordList',
      getMSRecord: 'api/MSSupportApi/getMSRecord',
      getWaiting: 'api/MSSupportApi/getWaiting',
      grabbing: 'api/MSSupportApi/grabbing',
      getStatusOptions: 'api/MSSupportApi/getStatusOptions',
      getRecordLogs: 'api/MSSupportApi/getRecordLogs',
      createLedger: 'api/MSSupportApi/createLedger'
    }
  }
}
